import { Edit } from '@mui/icons-material'
import { IconButton, Typography } from '@mui/material'
import { getPxAsRem } from 'shared/utils'
import { EDUCATION_SECTIONS } from '.'
import { TitleContainer } from '../styled'

export interface EducationSectionTitleContainerProps {
    setEditWithUnsavedChanges: (newEdit: EDUCATION_SECTIONS | null) => void
    edit: EDUCATION_SECTIONS | null
    sectionType: EDUCATION_SECTIONS
    title: string
    titleId?: string
}

const EducationSectionTitleContainer: React.FC<
    EducationSectionTitleContainerProps
> = ({ title, titleId, edit, sectionType, setEditWithUnsavedChanges }) => {
    return (
        <TitleContainer marginBottom={getPxAsRem(8)}>
            <Typography variant="h6" component="h2" id={titleId ?? title}>
                {title}
            </Typography>
            <IconButton
                disabled={edit === sectionType}
                onClick={() => {
                    setEditWithUnsavedChanges(sectionType)
                }}
            >
                <Edit fontSize="small" />
            </IconButton>
        </TitleContainer>
    )
}

export default EducationSectionTitleContainer
